<div class="page-wrap d-flex flex-row align-items-center">
    <div class="container" style="padding-top: 200px;">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <h1 style="color: #E65400" class="display-1 d-block"></h1>
                <div class="mb-4 lead">Usted no tiene acceso al Portal de acceso Online, debe tramitar su acceso con el Propietario del Contrato BHP o con el Administrador de contratos de su empresa</div>
                <!-- <button [routerLink]="['/']" class="btn btn-link">{{'NotFoundPortal.btnBack' | translate}}</button> -->
            </div>
        </div>
    </div>
</div>